module.exports = __webpack_public_path__ + "static/media/piston-2.416a4c20.mp3";